<template>
    <print-container :printableWidth="19">
        <div class="text-center title mt-8 mb-0">{{title}}</div>
        <!--<div class="text-center title mt-7 mb-2">{{landesverbandLocal}}</div>-->
        <div class="text-center subtitle-1 px-3 pb-0 my-0 font-weight-medium">Schnittliste
            {{print.location.toUpperCase()}} {{timeFrameLabel}}</div>
        <v-data-table :headers="print.headers" :items="print.schnittliste" hide-default-header
                      hide-default-footer mobile-breakpoint="1" :sort-by.sync="print.sortBy" :must-sort="true"
                      :sort-desc.sync="print.sortDesc" :search="print.search" dense disable-pagination
                      class="elevation-2 mt-7 mx-2 mb-5">
            <template v-slot:header="{}">
                <tr class="px-0">
                    <th class="headerCell py-2"></th>
                    <!--<th class="headerCell py-2"></th>-->
                    <th class="headerCell py-2">Pass</th>
                    <th class="headerCell py-2"></th>
                    <th class="headerCell py-2 text-left px-2">Name</th>
                    <th class="headerCell py-2 text-left px-4">
                        <span v-if="!print.showByTeam">Verein</span>
                        <span v-else>Mannschaft</span>
                    </th>
                    <td class="headerCell py-2 text-center">Heim</td>
                    <td class="headerCell py-2 text-center pr-2">Spiele</td>
                    <td class="headerCell py-2 text-center">Gast</td>
                    <td class="headerCell py-2 text-center pr-2">Spiele</td>
                    <td class="headerCell py-2 text-center">Gesamt</td>
                    <td class="headerCell py-2 text-center pr-2">Spiele</td>
                </tr>
            </template>
            <template v-slot:item="{ index, item }">
                <tr class="tableCell">
                    <td class="pr-2 tableCell">
                        <span v-if="item[print.location + 'Schnitt' + print.timeFrame] !== '0.00' && !print.search">
                        {{print.saison.getSchnittlistenPos(item, print.location, print.timeFrame)}}</span>
                        <span v-if="item[print.location + 'Schnitt' + print.timeFrame] !== '0.00' && print.search">
                        {{print.saison.getSchnittlistenPos(item, print.location, print.timeFrame)}}</span>
                        <span v-if="print.search" class="grey--text">
                             ({{index+1}})
                        </span>
                    </td>
                    <!--<td class="px-0">
                        <flag :iso="print.flags[item.nationalitaet]" :squared="false"
                              class="elevation-4 ma-2 d-inline-block">
                            {{item.nationalitaet}}
                        </flag>
                    </td>-->
                    <td class="py-2 px-0 tableCell">
                        <span v-if="item.passNr.indexOf('f')===0">-</span>
                        <span v-else>{{item.passNr}}</span>
                    </td>
                    <td class="px-2 tableCell">
                        <span>{{getAltersklasse(item)}}</span>
                    </td>
                    <td class="pr-0 pl-2 tableCell">
                        {{item.name}}
                    </td>
                    <td v-if='!print.showByTeam'
                        class="pr-2 borderRight tableCell">
                        {{item.verein}}
                    </td>
                    <td v-else
                        class="pr-2 borderRight tableCell">
                        {{item.team}}
                    </td>
                    <td :class="[{'font-weight-bold': print.location==='heim'}, 'pl-3 pr-2 text-right tableCell']">
                        <schnitt-feld :value="item['heimSchnitt' + print.timeFrame]"></schnitt-feld>
                    </td>
                    <td :class="[{'font-weight-bold': print.location==='heim'}, 'pl-3 pr-4 text-center borderRight tableCell']">
                        {{item['heimSpiele' + print.timeFrame]}}</td>
                    <td :class="[{'font-weight-bold': print.location==='gast'}, 'pl-3 pr-2 text-right']">
                        <schnitt-feld :value="item['gastSchnitt' + print.timeFrame]"></schnitt-feld>
                    </td>
                    <td :class="[{'font-weight-bold': print.location==='gast'}, 'pl-3 pr-4 text-center borderRight tableCell']">
                        {{item['gastSpiele' + print.timeFrame]}}</td>
                    <td :class="[{'font-weight-bold': print.location==='total'}, 'pl-3 pr-2 text-right tableCell']">
                        <schnitt-feld :value="item['totalSchnitt' + print.timeFrame]"></schnitt-feld>
                    </td>
                    <td :class="[{'font-weight-bold': print.location==='total'}, 'pl-3 pr-4 text-center tableCell']">
                        {{item['totalSpiele' + print.timeFrame]}}</td>
                </tr>
            </template>
            <template v-slot:no-data>
                Für diese Auswahl kann noch keine Schnittliste berechnet werden!
            </template>
        </v-data-table>
    </print-container>
</template>

<script>
    import PrintContainer from "./printContainer";
    import SpielService from "../../../services/data/spielService";
    import SchnittFeld from "../components/schnittFeld";

    export default {
        components: {
            SchnittFeld,
            PrintContainer},
        name: "print-schnittliste",
        computed: {
            print(){ return this.$store.state.local.printContainer; },
            title(){
                return this.$store.state.realtime
                    .landesverbaende[this.print.saison.lvId].ligen[this.print.saison.ligaId].nameFull +
                    ' ' + this.print.saison.sportJahr.replace('_', '/');
            },
            timeFrameLabel(){
                let label = ''
                switch (this.print.timeFrame) {
                    case 'T': label = 'Gesamtjahr'; break;
                    case 'H': label = 'Herbst'; break;
                    case 'F': label = 'Frühjahr'; break;
                }
                return label;
            }
        },
        created(){
            this.$store.state.local.printBackReset = {
                search: this.print.search,
                tab: 2,
                timeFrame: this.print.timeFrame,
                location: this.print.location,
                showByTeam: this.print.showByTeam,
                roundFrom: this.print.roundFrom,
                roundUntil: this.print.roundUntil,
            }
        },
        methods: {
            getAltersklasse(spieler){
                return SpielService.getAltersklasse(spieler.akHJ, spieler.akJahr, this.print.saison.id)
            },
        },

    }
</script>

<style scoped>
    .headerCell { font-size: 12px; font-weight: 600; color: #777;
        border-bottom: solid #ddd 1px;}
    .tableCell { font-size: 12px;}
    .borderRight {border-right: solid 1px lightgrey}
</style>